// src/features/salesPerson/routes.tsx
import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/app/routing/rootRoute';
import SalesPerson from './pages/salesPerson/SalesPerson';
import SalesPersonForm from './pages/salesPerson/SalesPersonForm';
import { hasPermission } from '../../common/services/permissionService';
import { API_ENDPOINTS } from './api/apiEndpoints';
import { getPermissionKeyFromApi } from '../../common/components/fromatPermission';

//export const salesPersonRoute = createRoute({
//  getParentRoute: () => rootRoute,
//    path: '/sales-person',
//});


export const salesPersonPageRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/sales-person',
    component: SalesPerson,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.SALESPERSON.SEARCH_SALESPERSON || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const salesPersonFormRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: 'sales-person/form',
    component: SalesPersonForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.SALESPERSON.SAVE_SALESPERSON || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const salesPersonRoutes = [
    //salesPersonRoute,
    salesPersonPageRoute,
    salesPersonFormRoute
];